<template>
  <div class="contentBlock">
    <el-container>
      <el-header>
        <div class="search">
          <header id="title">| 筛选条件</header>
          <div class="form">
            <el-form
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-form-item label="输出类型：">
                <el-select
                  v-model="formInline.transactionType"
                  style="width: 100px"
                  @change="changeTransactionType"
                >
                  <el-option label="运单号" value="1"></el-option>
                  <el-option label="箱号" value="2"></el-option>
                  <el-option label="发货单号" value="3"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="运输类型：">
                <el-select
                  v-model="formInline.transportType"
                  style="width: 100px"
                  clearable
                >
                  <el-option label="所有" value=""></el-option>
                  <el-option label="海运" value="1"></el-option>
                  <el-option label="空运" value="2"></el-option>
                  <el-option label="海运大件" value="3"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="时间范围:">
                <el-date-picker
                  v-model="formInline.checkedTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate(formInline.checkedTime)"
                  clearable
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="批次：">
                <el-select
                  v-model="formInline.checkedBatch"
                  style="width: 160px; padding-right: 6px"
                  remote
                  @change="batchChange"
                  @clear="clearChecked"
                  :remote-method="remoteMethod"
                  reserve-keyword
                  filterable
                  :loading="loading"
                  clearable
                  placeholder="请输入批次"
                >
                  <el-option
                    v-for="batchObj in batchArr"
                    :key="batchObj.sendId"
                    :label="batchObj.remark"
                    :value="batchObj.remark"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="状态类型：">
                <el-select
                  v-model="formInline.statusType"
                  style="width: 100px"
                  placeholder=""
                  :disabled="formInline.transactionType == 3"
                  clearable
                >
                  <el-option
                    v-for="(statusObj, pIndex) in statusArr"
                    :key="pIndex"
                    :label="statusObj.name"
                    :value="statusObj.value"
                    :disabled="
                      statusObj &&
                      (statusObj.value == 1 || statusObj.value == 2) &&
                      !!formInline.checkedBatch
                    "
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="人员：" class="people">
                <div>
                  <el-select
                    v-model="formInline.checkedPerson"
                    style="width: 100px"
                    clearable
                  >
                    <el-option label="所有" value=""></el-option>
                    <el-option
                      v-for="(peopleObj, pIndex) in peopleArr"
                      :key="pIndex"
                      :label="peopleObj.vipCode"
                      :value="peopleObj.vipCode"
                    ></el-option>
                  </el-select>
                </div>
                <div>
                  <el-button
                    icon="el-icon-search"
                    @click="showUserDialog"
                    class="search-icon"
                  ></el-button>
                </div>
              </el-form-item>

              <el-form-item label="派送点：" style="margin-left: 56px">
                <el-select
                  v-model="formInline.deliverAddress"
                  style="width: 140px"
                  clearable
                  :disabled="roleId==3"
                >
                  <el-option label="所有" value=""></el-option>
                  <el-option
                    v-for="(addressObj, aIndex) in deliverAddressArr"
                    :key="aIndex"
                    :label="addressObj.deliveryTitle"
                    :value="addressObj.adminId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" size="small" @click="search"
                  >筛选数据</el-button
                >
                <el-button type="primary" size="small" @click="exportToExcel"
                  >导出</el-button
                >
                
                
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-header>
      <el-main style="margin-top: 100px; box-sizing: border-box">
        <div class="bodyContent">
          <div class="navCalss" v-if="showWhichTable == 1">| 运单页</div>
          <div class="navCalss" v-if="showWhichTable == 2">| 箱号页</div>
          <div class="navCalss" v-if="showWhichTable == 3">| 发货单页</div>
          <!-- 表格部分 -->

          <div class="table">
            <div class="table_in" style="max-width: 1700px">
              <!-- 运单页表格start -->
              <el-table
                v-if="showWhichTable == 1"
                :data="tableData"
                stripe
                max-height="600px"
              >
                <el-table-column
                  prop="orderNo"
                  label="订单编号"
                  width="160"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.orderNo }}
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="180"
                  align="center"
                  prop="expressNo"
                  label="运单号"
                  :key="12"
                >
                  <template slot-scope="scope">
                    <span class="boxTag" v-if="scope.row.isDelivery">
                      {{ scope.row.isDelivery ? "派" : "" }}
                    </span>

                    {{ scope.row.expressNo ? scope.row.expressNo : "" }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="addTime"
                  label="下单时间"
                  min-width="150"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.addTime ? changeDate(scope.row.addTime, 1) : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="arrProduct"
                  label="名称"
                  min-width="120"
                  align="center"
                  ><template slot-scope="scope">
                    {{ scope.row.arrProduct }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="货物类型"
                  prop="goodType"
                  width="150px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>
                      <span class="tag" v-if="scope.row.goodType == 1">{{
                        goodType(scope.row.goodType)
                      }}</span>
                      <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                        goodType(scope.row.goodType)
                      }}</span>
                      <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                        goodType(scope.row.goodType)
                      }}</span>
                      {{ scope.row.goodName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="派送点"
                  prop="deliveryTitle"
                  width="120px"
                  align="left"
                >
                  <template slot-scope="scope">
                    {{ scope.row.deliveryTitle }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="realName"
                  label="客户"
                  width="80"
                  align="center"
                >
                </el-table-column>
                <el-table-column label="vip号" min-width="80px" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.vipCode }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="mobile"
                  width="120"
                  label="联系方式"
                  align="center"
                >
                </el-table-column>
                <el-table-column label="批次" align="center" width="120px">
                  <template slot-scope="scope">
                    {{ scope.row.sendRemark }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="expressCompany"
                  width="100"
                  label="物流公司"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="orderNo"
                  align="center"
                  width="160"
                  label="摘要"
                >
                </el-table-column>

                <el-table-column label="状态" width="90px" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status == 1" style="color: #d9001b">
                      待入库
                    </div>
                    <div
                      v-else-if="scope.row.status == 2"
                      style="color: #f59a23"
                    >
                      已入库
                    </div>
                    <div
                      v-else-if="scope.row.status == 3"
                      style="color: #70b603"
                    >
                      已出库
                    </div>
                    <div
                      v-else-if="scope.row.status == 4"
                      style="color: #70b603"
                    >
                      已结单
                    </div>
                    <div v-else-if="scope.row.status == -1" style="color: gray">
                      已取消
                    </div>
                    <div
                      v-else-if="scope.row.status == 6"
                      style="color: #f59a23"
                    >
                      已合箱
                    </div>
                    <div
                      v-else-if="scope.row.status == 7"
                      style="color: #f59a23"
                    >
                      （中心仓）已入库
                    </div>
                    <div
                      v-else-if="scope.row.status == 8"
                      style="color: #70b603"
                    >
                      （中心仓）已出库
                    </div>
                    <div
                      v-else-if="scope.row.status == 9"
                      style="color: #f59a23"
                    >
                      （派送）已入库
                    </div>
                    <div
                      v-else-if="scope.row.status == 10"
                      style="color: #ffa500"
                    >
                      可预约
                    </div>
                    <div
                      v-else-if="scope.row.status == 11"
                      style="color: #008000"
                    >
                      已预约
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="运费"
                  min-width="70px"
                  align="center"
                  prop="total"
                >
                  <template slot-scope="scope">
                    {{ scope.row.total | priceFilt }}
                  </template>
                </el-table-column>

                <el-table-column
                  label="工单费（CAD）"
                  min-width="140px"
                  align="center"
                  prop="demandMoney"
                >
                </el-table-column>
                <el-table-column
                  label="派送费(CAD)"
                  min-width="140px"
                  align="center"
                  prop="deliveryPrice"
                >
                </el-table-column>
                <el-table-column
                  label="额外费用（CAD）"
                  min-width="160px"
                  align="center"
                  prop="extraPrice"
                >
                </el-table-column>


                <el-table-column
                  label="签收状态"
                  prop="isReceipt"
                  min-width="90px"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.isReceipt ? "已签收" : "未签收" }}
                  </template>
                </el-table-column>
              </el-table>
              <!-- 运单页表格end -->

              <!-- 发货单表格start -->
              <el-table
                v-if="showWhichTable == 3"
                :data="sendOrderList"
                border
                style="width: 100%"
                stripe
              >
                <el-table-column
                  label="发货编号"
                  prop="sendNo"
                  min-width="220px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
              class="boxTag"
              v-if="scope.row.isDelivery"
            >
              {{ scope.row.isDelivery ? "派" : "" }}
            </span>
                    <span>{{ scope.row.sendNo ? scope.row.sendNo : "" }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="发货单生成时间"
                  prop="sendTime"
                  width="160px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.sendTime ? changeDate(scope.row.sendTime) : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="VIP号"
                  prop="vipCode"
                  min-width="80px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.user ? showUserVipCode(scope.row.user) : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="用户名"
                  prop="realName"
                  min-width="80px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.user ? showRealName(scope.row.user) : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="订单数量"
                  prop="orderCount"
                  min-width="80px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.orderCount ? scope.row.orderCount : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="实收费用 CAD"
                  prop="amount"
                  width="120px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  label="余额"
                  width="120px"
                  align="center"
                  prop="userBalance"
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.user ? showBalance(scope.row.user) : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="额外费用"
                  prop="extraPrice"
                  width="120px"
                  align="center"
                >
                </el-table-column>
                

                <el-table-column
                  label="批次"
                  prop="remark"
                  min-width="180px"
                  align="center"
                >
                <template slot-scope="scope">
                    <span>{{
                      scope.row.remark
                    }}</span>
                  </template>
                </el-table-column>
                
                <el-table-column
                  label="签收状态"
                  prop="isReceipt"
                  min-width="90px"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.isReceipt ? "已签收" : "未签收" }}
                  </template>
                </el-table-column>
              </el-table>
              <!-- 发货单表格end -->

              <!-- 箱号页表格start -->
              <el-table
                v-if="showWhichTable == 2"
                :data="boxList"
                stripe
                max-height="600px"
              >
                <el-table-column
                  prop="boxNumber"
                  label="合箱编码"
                  align="center"
                  width="200px"
                >
                  <template slot-scope="scope">
                    <span
                      class="boxTag"
                      v-if="(scope.row.vipCodes || '').split(',').length > 1"
                    >
                      {{
                        (scope.row.vipCodes || "").split(",").length > 1
                          ? "混"
                          : ""
                      }}
                    </span>
                    {{ scope.row.boxNumber }}
                  </template>
                </el-table-column>
                <el-table-column label="货物类型" align="center" width="100px">
                  <template slot-scope="scope">
                    <span>
                      <span class="tag" v-if="scope.row.goodType == 1">{{
                        goodType(scope.row.goodType)
                      }}</span>
                      <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                        goodType(scope.row.goodType)
                      }}</span>
                      <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                        goodType(scope.row.goodType)
                      }}</span>
                      {{ scope.row.goodName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="center" width="80px">
                  <template slot-scope="scope">
                    {{ scope.row.orderCount }}
                  </template>
                </el-table-column>
                <el-table-column label="用户VIP号" align="center" width="100px">
                  <template slot-scope="scope">
                    {{ scope.row.vipCodes }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="批次"
                  prop="sendRemark"
                  min-width="180px"
                  align="center"
                >
                 <template slot-scope="scope">
                    {{ scope.row.sendRemark }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="箱号"
                  prop="boxNumber"
                  min-width="180px"
                  align="center"
                >
                </el-table-column>
                <!-- <el-table-column label="派送点" align="left" min-width="180px">
          <template slot-scope="scope">
            <div>
              <h5 v-for="(delivalue,indexs) in deliverArr" :key="indexs">
                <h5>{{delivalue.addressId === scope.row.addressId ? delivalue.deliveryTitle : ""}}</h5>
              </h5>
            </div>
            {{ scope.row.address }}
          </template>
        </el-table-column> -->
                <el-table-column label="状态" align="center" width="80px">
                  已合箱
                </el-table-column>
              </el-table>
              <!-- 箱号页表格end -->
            </div>

            <div style="float: right; margin-top: 20px; padding-right: 40px">
              <!-- 运单页分页 start -->
              <el-pagination
                v-if="showWhichTable == 1"
                :page-sizes="paginations.page_sizes"
                :page-size="paginations.page_size"
                :layout="paginations.layout"
                :total="paginations.total"
                :current-page="paginations.page_index"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
              >
              </el-pagination>
              <!-- 运单页分页 end -->

              <!-- 箱号页分页 start -->
              <el-pagination
                v-if="showWhichTable == 2"
                :page-sizes="paginationsBox.page_sizes"
                :page-size="paginationsBox.page_size"
                :layout="paginationsBox.layout"
                :total="paginationsBox.total"
                :current-page="paginationsBox.page_index"
                @current-change="handleCurrentChangeBox"
                @size-change="handleSizeChangeBox"
              >
              </el-pagination>
              <!-- 箱号页分页 end -->

              <!-- 发货单分页 start -->
              <el-pagination
                v-if="showWhichTable == 3"
                :page-sizes="paginationsPerson.page_sizes"
                :page-size="paginationsPerson.page_size"
                :layout="paginationsPerson.layout"
                :total="paginationsPerson.total"
                :current-page="paginationsPerson.page_index"
                @current-change="handleCurrentChangePerson"
                @size-change="handleSizeChangePerson"
              >
              </el-pagination>
              <!-- 发货单分页 end -->
            </div>
          </div>
        </div>
      </el-main>
    </el-container>

    <!--指定人员的Dialog start -->
    <el-dialog
      :visible.sync="isShowUserDialog"
      :append-to-body="true"
      width="600px"
    >
      <div slot="title" class="roleData dialogTitle">
        <i class="icon"></i>
        <span class="title-text">人员选择</span>
        <hr />
        <br />
        <span>客户/vipCode：</span>
        <el-input
          v-model="roleInput"
          placeholder="请输入内容"
          style="width: 200px"
          size="small"
          clearable
        ></el-input>
        <el-button type="primary" size="small" @click="searchRole"
          >查询</el-button
        >
        <el-button type="primary" size="small" @click="setRole">重置</el-button>
        <br /><br /><br />
        <el-table
          :data="roleData"
          border
          :max-height="580"
          ref="multipleTableRole"
          @select="selectRoleOnce"
          @selection-change="selectOptionChange"
          class="table"
        >
          <el-table-column prop="date" type="selection" width="55">
          </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column
            prop="vipCode"
            label="vipCode"
            align="center"
            width="100"
          >
          </el-table-column>

          <el-table-column
            prop="realName"
            label="客户"
            align="center"
            min-width="100"
          >
          </el-table-column>
        </el-table>

        <div>
          <el-pagination
            class="pagination"
            background
            @size-change="rHandleSizeChange"
            @current-change="rHandleCurrentChange"
            :current-page="rolePaginations.page_index"
            :page-sizes="rolePaginations.page_sizes"
            :page-size="rolePaginations.page_size"
            layout="total, sizes, prev, pager, next"
            :total="rolePaginations.total"
          >
          </el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRole()" type="primary" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="certainRole()" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!--指定角色的Dialog end -->
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as deliveryApi from "@/api/delivery";
import * as order from "@/api/order";
import * as book from "../../api/book";
import * as statisticalApi from "../../api/statistical";

export default {
  data() {
    return {
      // 表单
      formInline: {
        transactionType: "1",
        transportType: null,
        statusType: "",
        checkedPerson: null,
        checkedTime: "",
        checkedBatch: "",
        checkedRole: "",
        deliverAddress: null,
      },

      // 人员数组
      peopleArr: [],

      deliverAddressArr: [],

      // 选择的时间对应的起始时间戳
      startTime: "",
      endTime: "",

      // 批次数组
      batchArr: [],
      loading: false,

      // 状态数组
      statusArr: [],
      // 运单状态
      orderStatusArr: [
        // {
        //   name: "待入库",
        //   key: "1",
        //   value: "1",
        // },
        // {
        //   name: "已入库",
        //   key: "2",
        //   value: "2",
        // },
        // {
        //   name: "已出库",
        //   key: "3",
        //   value: "3",
        // },
        
        // {
        //   name: "中心仓已入库",
        //   key: "7",
        //   value: "7",
        // },
        {
          name: "中心仓已出库",
          key: "8",
          value: "8",
        },
        {
          name: "派送已入库",
          key: "9",
          value: "9",
        },
        {
          name: "可预约",
          key: "10",
          value: "10",
        },
        {
          name: "已预约",
          key: "11",
          value: "11",
        },
        {
          name: "已结单",
          key: "4",
          value: "4",
        },
      ],
      orderStatusArr2: [
        {
          name: "待入库",
          key: "1",
          value: "1",
        },
        {
          name: "已入库",
          key: "2",
          value: "2",
        },
        {
          name: "已出库",
          key: "3",
          value: "3",
        },
        
        {
          name: "中心仓已入库",
          key: "7",
          value: "7",
        },
        {
          name: "中心仓已出库",
          key: "8",
          value: "8",
        },
        {
          name: "派送已入库",
          key: "9",
          value: "9",
        },
        {
          name: "可预约",
          key: "10",
          value: "10",
        },
        {
          name: "已预约",
          key: "11",
          value: "11",
        },
        {
          name: "已结单",
          key: "4",
          value: "4",
        },
      ],
      // 箱子状态
      boxStatusArr: [
        {
          name: "已合箱",
          key: "0",
          value: "0",
        },

        {
          name: "已出库",
          key: "3",
          value: "3",
        },

        {
          name: "分拨已入库",
          key: "7",
          value: "7",
        },
        {
          name: "分拨已出库",
          key: "8",
          value: "8",
        },
        {
          name: "派送已入库",
          key: "9",
          value: "9",
        },
      ],

      tableData: [],
      sendOrderList: [], //发货单页列表数据
      boxList: [], // 箱号页列表数据
      // 运单页分页
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      // 发货单分页
      paginationsPerson: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      // 箱号分页
      paginationsBox: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },

      deliveryList: [], // 派送点列表
      showWhichTable: 1, // 展示哪个表格 1运单2.箱号单3.发货单
      customerList: [], //列表,
      // F7 人员选择弹框
      isShowUserDialog: false,
      // F7 人员选择弹框 角色名称 搜索字段
      roleInput: "",
      // F7 人员选择弹框 表格数据
      roleData: [],
      //F7分页 需要给分页组件传的信息
      rolePaginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [10, 20, 50, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      rowSelection: [],
      // 当前表格对应的总页数 用于导出表格
      howManyTotal: 0,
      // 存放导出excel的表格数据
      listArr: [],

      billColumn: [
        { title: "订单编号", key: "orderNo" },
        { title: "下单时间", key: "addTime" },
        { title: "名称", key: "arrProduct" },
        { title: "货物类型", key: "goodType" },
        { title: "派送点", key: "deliveryTitle" },
        { title: "客户", key: "realName" },
        { title: "vip号", key: "vipCode" },
        { title: "联系方式", key: "mobile" },
{ title: "批次", key: "sendRemark" },
        { title: "物流公司", key: "expressCompany" },
        { title: "摘要", key: "orderNo" },
        { title: "运单号", key: "expressNo" },
        { title: "状态", key: "status" },
        { title: "运费", key: "total" },
        { title: "工单费（CAD）", key: "demandMoney" },
        { title: "派送费(CAD)", key: "deliveryPrice" },
        { title: "额外费用（CAD）", key: "extraPrice" },
         { title: "签收状态", key: "isReceipt" },
      ],

      boxColumn: [
        { title: "合箱编码", key: "boxNumber" },
        { title: "货物类型", key: "goodType" },
        { title: "订单数量", key: "orderCount" },
        { title: "用户VIP号", key: "vipCodes" },
        { title: "批次", key: "batchNumber" },
        { title: "箱号", key: "boxNumber" },
        { title: "状态", key: "boxStatus" },
      ],

      sendOrderColumn: [
        { title: "发货编号", key: "sendNo" },
        { title: "发货单生成时间", key: "sendTime" },
        { title: "VIP号", key: "vipCode" },
        { title: "用户名", key: "realName" },
        { title: "订单数量", key: "orderCount" },
        { title: "实收费用CAD", key: "amount" },
        { title: "余额", key: "userBalance" },
        { title: "额外费用", key: "extraPrice" },
        { title: "批次", key: "remark" },
        { title: "签收状态", key: "isReceipt" },
      ],

      // 表示当前登录账号类型
      roleId:null,
      // 人员对应的派送点参数值
      peopleAddressId:null,
      // 导出时的派送点参数
      exportAddressId:null,
    };
  },
  created() {
    // this.init();
    this.getBatchList();
    this.getAdressId();
    this.getDeliveryList();
    this.getSendOrderList();
    
    
  },
  mounted(){
    let userinfo=mUtils.getStore('userinfo');
    
    if(userinfo.roleId == 3){
      this.roleId = 3;
      this.formInline.deliverAddress = userinfo.adminId;
      this.statusArr = this.orderStatusArr;
    }else{
      this.statusArr = this.orderStatusArr2;
    }
    
  },
  watch: {},
  methods: {
    // 初始化页面
    // init() {
    //   this.statusArr = this.orderStatusArr;
    // },

    changeTransactionType(value) {
      if (value == 1) {
        if(this.roleId == 3){
          this.statusArr = this.orderStatusArr;
        }else{
          this.statusArr = this.orderStatusArr2;
        }
        
        // this.formInline.statusType = "2";
        this.showWhichTable = "1";
        // this.formInline.transactionType = "1";
        // this.getWayBillList(null, null, 1);
        this.tableData = [];
      } else if (value == 2) {
        this.statusArr = this.boxStatusArr;
        // this.formInline.statusType = "0";
        this.showWhichTable = "2";
        // this.formInline.transactionType = "2";
        // this.getBoxList(null, null, 2);
        this.boxList = [];
      } else {
        this.statusArr = [];
        // this.formInline.statusType = "";
        this.showWhichTable = "3";
        // this.formInline.transactionType = "3";
        // this.getSendOrderList(null, null, 3);
        this.sendOrderList = [];
      }
    },
    search() {
      let type = this.formInline.transactionType;
      if (type == 1) {
        this.getWayBillList(null, null, 1);
      } else if (type == 2) {
        this.getBoxList(null, null, 2);
      } else {
        this.getSendOrderList(null, null, 3);
      }
    },

    // 将选择的时间转换为时间戳
    getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },

    // 获取运单列表
    getWayBillList(page, size, numType) {
      let that = this;
      let param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        type: this.formInline.transactionType,
        goodType: this.formInline.transportType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "",
        status: this.formInline.statusType,
        // addressId: this.formInline.deliverAddress,
        addressId: null,

        vipCode: this.formInline.checkedPerson,
      };

      // 如果选择了派送点或者已有派送点
      if(this.formInline.deliverAddress){
        that.deliveryList.forEach((dItem,index)=>{
          if(dItem.adminId == this.formInline.deliverAddress){
            this.exportAddressId = param.addressId = dItem.addressId;
          }
        })
      }else{
        console.log(1106,this.formInline.deliverAddress);
      }

      statisticalApi.getWayBillList(param).then((res) => {
        if (res.status !== 200) {
          return this.$message.error(res.msg);
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          this.tableData = res.data.data.list;
          this.paginations.total = res.data.data.pageCount
            ? res.data.data.pageCount
            : 0;
          this.howManyTotal = this.paginations.total;
        }
      });
    },

    // 获取箱号列表
    getBoxList(page, size, numType) {
      let that = this;
      this.tableData = [];
      let param = {
        pageIndex: this.paginationsBox.page_index,
        pageSize: this.paginationsBox.page_size,
        type: this.formInline.transactionType,
        goodType: this.formInline.transportType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "",
        status: this.formInline.statusType,
        // addressId: this.formInline.deliverAddress,
        addressId: null,
        vipCode: this.formInline.checkedPerson,
      };

      // 如果选择了派送点或者已有派送点
      if(this.formInline.deliverAddress){
        that.deliveryList.forEach((dItem,index)=>{
          if(dItem.adminId == this.formInline.deliverAddress){
            this.exportAddressId = param.addressId = dItem.addressId;
          }
        })
      }

      statisticalApi.getWayBillList(param).then((res) => {
        if (res.status !== 200) {
          return this.$message.error(res.msg);
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          this.boxList = res.data.data.list;
          this.paginationsBox.total = res.data.data.pageCount
            ? res.data.data.pageCount
            : 0;
          this.howManyTotal = this.paginationsBox.total;
        }
      });
    },

    // 日期转换
    changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },

    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getWayBillList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getWayBillList();
    },

    // 发货单 每页多少条切换
    handleSizeChangePerson(page_size) {
      let that = this;
      that.paginationsPerson.page_size = page_size;
      that.getSendOrderList();
    },
    // 发货单 上下分页
    handleCurrentChangePerson(page) {
      let that = this;
      that.paginationsPerson.page_index = page;
      that.getSendOrderList();
    },

    // 箱号 每页多少条切换
    handleSizeChangeBox(page_size) {
      let that = this;
      that.paginationsBox.page_size = page_size;
      this.getBoxList(null, null, 2);
    },
    // 箱号 上下分页
    handleCurrentChangeBox(page) {
      let that = this;
      that.paginationsBox.page_index = page;
      this.getBoxList(null, null, 2);
    },

    // 获取发货单列表
    getSendOrderList(page, size, num) {
      let that = this;
      let data = {
        pageIndex: that.paginationsPerson.page_index,
        pageSize: that.paginationsPerson.page_size,
        type: this.formInline.transactionType,
        goodType: this.formInline.transportType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "",
        // addressId: this.formInline.deliverAddress,
        addressId: null,
        vipCode: this.formInline.checkedPerson,
      };

      // 如果选择了派送点或者已有派送点
      if(this.formInline.deliverAddress){
        that.deliveryList.forEach((dItem,index)=>{
          if(dItem.adminId == this.formInline.deliverAddress){
            this.exportAddressId = data.addressId = dItem.addressId;
          }
        })
      }

      let val = JSON.parse(localStorage.getItem("userinfo"));
      if (val.roleId !== 1) {
        data.adminId = val.adminId;
      }
      statisticalApi.getWayBillList(data).then((res) => {
        if (res.data.code == 0) {

          that.sendOrderList = res.data.data.list;

          that.paginationsPerson.total = res.data.data.pageCount;
          this.howManyTotal = that.paginationsPerson.total;
        } else {
          that.$message.error("获取发货单列表失败");
        }
      });
    },

    // 获取派送点 列表
    getDeliveryList() {
      let that = this;
      let data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then((res) => {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];
          this.getCustomer();
          this.getRoleList();
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },

    //表格序号
    getIndex($index) {
      return (
        (this.paginationsPerson.page_index - 1) *
          this.paginationsPerson.page_size +
        $index +
        1
      );
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchArr = res.data.data;
          } else {
            that.batchArr = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      // this.getDeliveryList();
    },

    batchChange() {
      // this.getDeliveryList();
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },

    //获取派送点
    getAdressId() {
      let uselist = mUtils.getStore("userinfo");
      let realName = uselist.realName;
      let roleId = uselist.roleId;
      book.deliveryList({ type: 2 }).then((res) => {
        if (res.status !== 200) {
          return this.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return this.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          this.deliverAddressArr = res.data.data.list;
        }
      });
    },

    goodType(goodType) {
      let str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },

    showUserVipCode(user) {
      if (!(JSON.stringify(user) == "{}")) {
        if (user.vipCode) {
          return user.vipCode;
        } else {
          return "";
        }
      }
    },

    showRealName(user) {
      if (!(JSON.stringify(user) == "{}")) {
        if (user.realName) {
          return user.realName;
        } else {
          return "";
        }
      }
    },

    showBalance(user) {
      if (!(JSON.stringify(user) == "{}")) {
        if (user.balance) {
          return user.balance;
        } else {
          return "0";
        }
      }
    },

    // 获取客户列表
    getCustomer() {
      let that = this;
      let data = {};
      if(mUtils.getStore('roleID') && mUtils.getStore('roleID')==3){
        
        if(mUtils.getStore('userinfo') && mUtils.getStore('userinfo').adminId){
          
          const one = that.deliveryList.filter(item => item.adminId == mUtils.getStore('userinfo').adminId);
          if(one && one.length>0){
            this.peopleAddressId = one[0].addressId;
          }
          // data.deliveryId = mUtils.getStore('userinfo').adminId;
          data.deliveryId = this.peopleAddressId;

        }
      }
      statisticalApi.getCustomerList(data).then((res) => {

        if (res.data.code == 0) {
          if (res.data.data && res.data.data && res.data.data.list) {
            that.peopleArr = res.data.data.list;
          }
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },

    cancelRole() {
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },

    searchRole() {
      this.rolePaginations.page_index = 1;
      this.getRoleList();
    },

    setRole() {
      this.roleInput = "";
      this.getRoleList();
    },

    // 显示F7弹框 角色选择
    showUserDialog() {
      this.isShowUserDialog = true;
      this.roleInput = "";
    },

    certainRole() {
      if (
        this.rowSelection &&
        this.rowSelection[0] &&
        this.rowSelection[0].vipCode
      ) {
        this.formInline.checkedPerson = this.rowSelection[0].vipCode;
      }
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },

    // 角色选择弹框勾选列表
    selectOptionChange(val) {
      this.rowSelection = val;
    },
    selectRoleOnce(selection, row) {
      if (selection.length > 1) {
        let del_row = selection.shift();
        this.$refs.multipleTableRole.toggleRowSelection(del_row, false);
      }
    },

    // 获取人员f7数据
    getRoleList(num,size) {
      let param = {
        realName: this.roleInput ? this.roleInput.trim() : "",
        pageIndex: this.rolePaginations.page_index,
        pageSize: this.rolePaginations.page_size,
      };
      if(mUtils.getStore('roleID') && mUtils.getStore('roleID')==3){
        
        if(mUtils.getStore('userinfo') && mUtils.getStore('userinfo').adminId){
          
          param.deliveryId = this.peopleAddressId;
        }
      }
      statisticalApi.getCustomerList(param).then((res) => {
        if (res.data.code !== 0)
          return this.$message.error("获取人员数据失败: " + res.data.msg);
        if (res.data && res.data.data && res.data.data && res.data.data.list) {
          this.roleData = res.data.data.list;
          this.rolePaginations.total = res.data.data.pageCount;
        }
      });
    },

    rHandleSizeChange(page_size) {
      this.rolePaginations.page_size = page_size;
      this.getRoleList(null,page_size);
    },
    rHandleCurrentChange(page) {
      this.rolePaginations.page_index = page;
      this.getRoleList(page,null);
    },

    // 导出excel
    exportToExcel() {
      let that = this;
      let param = {
        pageIndex: 1,
        pageSize: 400,
      };

      const howManyPage = Math.ceil((that.howManyTotal * 1) / 400);
      let orderName = ""; // excel名称
      let columns = [];
      if (this.formInline.transactionType == "1") {
        // 导出运单
        param["type"] = "1";
        param["goodType"] = this.formInline.transportType;
        param["start"] = this.startTime;
        param["end"] = this.endTime;
        param["batchNumber"] = this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "";
        param["status"] = this.formInline.statusType;
        // param["addressId"] = this.formInline.deliverAddress;
        param["addressId"] = this.exportAddressId;
        param["vipCode"] = this.formInline.checkedPerson;
        orderName = "统计-运单列表";
        columns = this.billColumn;
      } else if (this.formInline.transactionType == "2") {
        // 导出运单
        param["type"] = "2";
        param["goodType"] = this.formInline.transportType;
        param["start"] = this.startTime;
        param["end"] = this.endTime;
        param["batchNumber"] = this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "";
        param["status"] = this.formInline.statusType;
        // param["addressId"] = this.formInline.deliverAddress;
        param["addressId"] = this.exportAddressId;
        param["vipCode"] = this.formInline.checkedPerson;
        orderName = "统计-箱号列表";
        columns = this.boxColumn;
      } else {
        // 导出发货单
        param["type"] = "3";
        param["goodType"] = this.formInline.transportType;
        param["start"] = this.startTime;
        param["end"] = this.endTime;
        param["batchNumber"] = this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "";
        // param["addressId"] = this.formInline.deliverAddress;
        param["addressId"] = this.exportAddressId;
        param["vipCode"] = this.formInline.checkedPerson;
        orderName = "统计—发货单列表";
        columns = this.sendOrderColumn;
      }

      this.getExportData(param, howManyPage, orderName, columns);
    },

    // 运单状态转换用于导出
    getOrderStatus(status){
      if(status == 1){
        return "待入库";
      }else if(status == 2){
        return "已入库";
      }else if(status == 3){
        return "已出库";
      }else if(status == 4){
        return "已结单";
      }else if(status == -1){
        return "已取消";
      }else if(status == 6){
        return "已合箱";
      }else if(status == 7){
        return "（中心仓）已入库";
      }else if(status == 8){
        return "（中心仓）已出库";
      }else if(status == 9){
        return "（派送）已入库";
      }else if(status == 10){
        return "可预约";
      }else if(status == 11){
        return "已预约";
      }else{
        return "";
      }
    },

    // 获得需要导出的数据
    async getExportData(param, howManyPage, orderName, columns) {
      let that = this;
      let listArr = [];
      for (let i = 1; i <= howManyPage; i++) {
        param.pageIndex = i;
        await statisticalApi.getWayBillList(param).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.list) {
              res.data.data.list.map((every, index) => {
                if (param.type == 1) {
                  // 运单
                  every.addTime = mUtils
                    .formatDate(new Date(every.addTime))
                    .substring(0, 19);
                                    if (every.goodType == 1) {
                    every.goodType = "海运";
                  } else if (every.goodType == 2) {
                    every.goodType = "海运大件";
                  } else if (every.goodType == 3) {
                    every.goodType = "空运";
                  } else {
                    every.goodType = "";
                  };
                  every.status = this.getOrderStatus(every.status);
                  every.isReceipt=every.isReceipt==1 ? "已签收" :every.isReceipt==0? "未签收" :"";
                } else if (param.type == 2) {
                  // 箱号
                  if (every.goodType == 1) {
                    every.goodType = "海运";
                  } else if (every.goodType == 2) {
                    every.goodType = "海运大件";
                  } else if (every.goodType == 3) {
                    every.goodType = "空运";
                  } else {
                    every.goodType = "";
                  }
                  every.boxStatus = "已合箱";
                } else {
                  // 发货单
                  every.sendTime = mUtils
                    .formatDate(new Date(every.sendTime))
                    .substring(0, 19);
                  if (every.user && every.user.vipCode) {
                    every.vipCode = every.user.vipCode;
                  }
                  if (every.user && every.user.realName) {
                    every.realName = every.user.realName;
                  }
                  if (every.user && every.user.balance) {
                    every.userBalance = every.user.balance;
                  } else {
                    every.userBalance = "0";
                  }
                  every.operatorTime = mUtils
                    .formatDate(new Date(every.operatorTime))
                    .substring(0, 19);
                }
                every.isReceipt = every.isReceipt ? "已签收" : "未签收";

                listArr.push(every);
              });

              // that.getAllData(res.data.data.pageCount);
            }
          }
        });
      }
      that.listArr = listArr;
      mUtils.export2Excel(columns, listArr, orderName);
    },
  },
};
</script>
<style  lang="less" scoped>
.contentBlock {
  width: 100%;
  min-height: 100%;
  margin: 20px 50px 50px 30px;
  & .search {
    width: 100%;
    // height:100px;
    // border: solid;
    & #title {
      font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
        sans-serif;
      font-weight: 650;
      font-size: 18px;
    }
    & .form {
      margin-top: 20px;
      .search-icon {
        position: absolute;
        right: -56px;
        top: 0px;
      }
    }
  }

  & .bodyContent {
    width: 100%;
    min-height: 400px;
    margin-top: 30px;
    // border: solid;
    .navCalss {
      font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
        sans-serif;
      font-weight: 650;
      font-size: 18px;
      margin-bottom: 10px;
    }
    .table {
      padding-right: 38px;
    }
  }
}

.dialogTitle {
  padding-bottom: 10px;
  .icon {
    display: block;
    float: left;
    width: 10px;
    height: 20px;
    background: rgb(64, 158, 255);
  }
  .title-text {
    display: inline-block;
    padding: 0 0 6px 10px;
    line-height: 22px;
    font-weight: bold;
    font-size: 20px;
    color: rgb(64, 158, 255);
  }
}
.dialog-footer {
  text-align: center;
  margin-top: -30px;
}
// 穿透
/deep/ .el-dialog__body {
  padding: 0px 20px 0 20px;
}

.boxTag {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 4px;
  background-color: #ffa500;
  border-color: #faecd8;
  color: #fff;
}


</style>



// WEBPACK FOOTER //
// wayBill.vue?35871b33